import { useBaseQuery } from "./utils/useBaseQuery.js";
export function useLazyQuery(query, options) {
    return useBaseQuery(query, options, true);
}
//# sourceMappingURL=useLazyQuery.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/react/hooks/useLazyQuery.js
// module id = 1229
// module chunks = 118